(function (appComponents) {

	appComponents.controllers.cartOverview = function (Components) {
		var cartOverview = {};

		cartOverview.name = "cartOverview";

		Components.getControllerPrototype().extend(cartOverview);

		cartOverview._cart = cartOverview._getService("cartBase");
		cartOverview._b2bUnit = cartOverview._getService("b2bUnit");
		cartOverview._panda = cartOverview._getService("panda");
		cartOverview._modals = cartOverview._getService("modals");
		cartOverview._product = cartOverview._getService("productBase");
		cartOverview._layout = cartOverview._getService("layout");

		cartOverview.itemCollection = cartOverview._getPageComponent("cartItemCollection");

		cartOverview.elements = {
			get tableItems() {
				return $('[pc-container="cart--table-items"]');
			}
		};

		cartOverview.bindings = function () {
			cartOverview._elements.page.on("click", "[pc-container='cart--item-datapack']", function () {
				var entry = $(this).parent().closest('[pc-container="cart--item"]').attr("pc-value");
				var type = $(this).attr("pc-value");
				cartOverview.handlers.onDataPackItemClick(entry, type);
			});
			cartOverview._elements.page.on("click", '[pc-container="cart--item-title"]', function () {
				var entry = $(this).parent().closest('[pc-container="cart--item"]').attr("pc-value");
				cartOverview.handlers.onTitleClick(entry);
			});
			cartOverview._elements.page.on("click", '[pc-container="cart--reset-cart"]', function () {
				cartOverview.handlers.onResetCart();
			});
			cartOverview._elements.page.on("click", '[pc-container="cart--panda-more-info"]', function () {
				var entryNumber = $(this).parents('[pc-container="cart--item"]').attr("pc-value");
				cartOverview.handlers.onPandaMoreInfo(entryNumber);
			});
			cartOverview._elements.page.on("click", '[pc-container="cart--remove-item"]', function () {
				var entryNumber = $(this).parents('[pc-container="cart--item"]').attr("pc-value");
				cartOverview.handlers.onRemoveItem(entryNumber);
				if (!cartOverview._cart.cartSize) 
				{
					cartOverview._goToPage("index");
					return;
				}
				else
				{
					setTimeout(function(){ window.location.reload(); });
				}
			});
			cartOverview._elements.page.on("blur keypress", "[pc-container='cart--global-spa-field']", function (e) {
				var key = e.which;
				if (e.type == "keypress" && key != 13) return;
				var val = $(this).val();
				if (!val) return;
				cartOverview.handlers.onGlobalSpaInput(val);
			});
			cartOverview._elements.page.on("blur keypress", "[pc-container='cart--item-spa-field']", function (e) {
				var key = e.which;
				if (e.type == "keypress" && key != 13) return;
				var entryNumber = $(this).parents('[pc-container="cart--item"]').attr("pc-value");
				var val = $(this).val();
				if (!val) return;
				cartOverview.handlers.onItemSpa(entryNumber);
			});
			cartOverview._elements.page.on("change", "[pc-container='cart--item-spa-selector']", function (e, isGlobal) {
				if (isGlobal) return;
				var entryNumber = $(this).parents('[pc-container="cart--item"]').attr("pc-value");
				cartOverview.handlers.onItemSpa(entryNumber);
			});
			cartOverview._elements.page.on("blur", "[pc-container='cart--item-qty']", function () {
				var entryNumber = $(this).parents('[pc-container="cart--item"]').attr("pc-value");
				cartOverview.handlers.onItemQtyInput(entryNumber);
			});
			//Choosing items
			cartOverview._elements.page.on("ifChecked", "[pc-container='cart--choose-all-items']", function () {
				$('[pc-container="cart--choose-one-item"]').iCheck('check');
				$('[pc-container="cart--delete-items"]').removeAttr("disabled");
			});

			cartOverview._elements.page.on("ifUnchecked", "[pc-container='cart--choose-all-items']", function () {
				$('[pc-container="cart--choose-one-item"]').iCheck('uncheck');
				$('[pc-container="cart--delete-items"]').attr("disabled", true);
			});

			cartOverview._elements.page.on("ifChecked", "[pc-container='cart--choose-one-item']", function () {
				$('[pc-container="cart--delete-items"]').removeAttr("disabled");
			});


			cartOverview._elements.page.on("ifUnchecked", "[pc-container='cart--choose-one-item']", function () {
				if (!$('[pc-container="cart--choose-one-item"]:checked').length) {
					$('[pc-container="cart--delete-items"]').attr("disabled", true);
					$('[pc-container="cart--choose-all-items"]').iCheck('uncheck');
				}
			});

			//Removing items
			cartOverview._elements.page.on("click", "[pc-container='cart--delete-items']", function () {
				cartOverview.handlers.onRemoveCheckedItems();
			});
		};

		cartOverview.liveBindings = function () {
			// from TD core

			$('.spa-select-top').change(function () {
				var value = $(this).val();
				if (value == "not-listed") {
					$(this).closest('.spa-index-section').find('.spa-not-listed').show();
				} else {
					$(this).closest('.spa-index-section').find('.spa-not-listed').hide();
					cartOverview.handlers.onGlobalSpaInput(value);
				}
			});

			$('.spa-select').change(function () {
				var value = $(this).val();
				if (value == "not-listed") {
					$(this).closest('td').find('.spa-not-listed').show();
				} else {
					$(this).closest('td').find('.spa-not-listed').hide();
				}
			});
		};

		cartOverview.populateInitialContext = function () {
			cartOverview.context.isUnitSet = cartOverview._b2bUnit.isUnitSet;

			if (cartOverview._b2bUnit.isUnitSet) {
				cartOverview.context.unitType = cartOverview._b2bUnit.currentUnit.unitType;
			}


			return cartOverview.getCartItems();
		};

		cartOverview.getCartItems = function () {
			return cartOverview._cart.getCartItems().then(function (res) {
				if (res) {
					cartOverview.parseResponseData(res);
				}
			});
		};

		cartOverview.renderCartItems = function () {
			var html = cartOverview.templates.tableItems(cartOverview.context);
			cartOverview.elements.tableItems.html(html);


			// cartOverview._applyScript.all();
		};


		cartOverview.parseResponseData = function (data) {
			cartOverview.context.cart = data.body;
			cartOverview.context.entries = data.body.cartData.entries;
			cartOverview.context.kits = data.body.productAccessoriesRelation;
			cartOverview.context.flags.showOrderCheckoutBtn = true;

			var globalSpa = [];
			cartOverview.context.entries.forEach(function (entry) {
				if (!entry.product || !Array.isArray(entry.product.spaList)) return;

				entry.product.spaList.forEach(function (spa) {
					if (globalSpa.indexOf(spa) < 0) {
						globalSpa.push(spa);
					}
				});
			});
			cartOverview.context.globalSpa = globalSpa;
		};

		cartOverview.sapCheckRoutine = function () {
			if (!cartOverview._config.isSapEnabled) {
				var isPartsInCart = false;

				cartOverview.context.entries.forEach(function (el) {
					if (el.product.pcPart) isPartsInCart = true;
				});

				cartOverview.context.flags.showOrderCheckoutBtn = (isPartsInCart) ? false : true;
			}
		};

		cartOverview.handlers = {
			onTitleClick: function (entryNumber) {
				cartOverview.itemCollection.findItemByEntryNumber(entryNumber).showDetails();
			},
			onDataPackItemClick: function (entryNumber, type) {
				cartOverview.itemCollection.findItemByEntryNumber(entryNumber).downloadDataPack(type);
			},
			onPandaMoreInfo: function (entryNumber) {
				cartOverview.itemCollection.showPandaMoreInfo(entryNumber);
			},
			onResetCart: function () {
				cartOverview._cart.resetCart().then(function (isTrue) {
					if (isTrue) {
						cartOverview._goToPage("index");
					}
				});
			},
			onItemSpa: function (entryNumber) {
				cartOverview.itemCollection.findItemByEntryNumber(entryNumber).setItemSpa();
			},
			onItemQtyInput: function (entryNumber) {
				cartOverview.itemCollection.setItemQty(entryNumber);
			},
			onGlobalSpaInput: function (spaValue) {
				cartOverview.itemCollection.setGlobalSpa(spaValue);
			},
			onProductTitleClick: function (productCode) {
				var product = null;
				cartOverview.context.entries.forEach(function (el) {
					if (el.product.code == productCode) {
						product = el.product;
					}
				});
				cartOverview._stash.selectedProduct = product;
				var pageData = cartOverview._pages.productDetails;
				cartOverview._handlers.onSoftSwitchToPage(pageData);
			},
			onRemoveItem: function (entryNumber) {
				cartOverview.itemCollection.findItemByEntryNumber(entryNumber).remove();
			},
			onRemoveCheckedItems: function () {
				cartOverview._modals.confirm.showConfirm(cartOverview._messages.cart.removeCartItems).then(function (confirm) {
					if (confirm) {
						cartOverview.itemCollection.removeCheckedItems();
						setTimeout(function(){ window.location.reload(); });
					}
				});
			},
			onb2bUnitChange: function () {
				if (cartOverview._isActiveController) {
					cartOverview.init();
				}
			}
		};

		cartOverview.init = function () {

			cartOverview.populateInitialContext().then(function () {

				cartOverview.sapCheckRoutine();

				cartOverview._renderPageTemplate();

				cartOverview.itemCollection.setCollection(cartOverview.context.entries);

				cartOverview._bindings();

				cartOverview._events.dispatchEvent("controllerInitialized");
				cartOverview._events.registerHandlerAsLastOne("b2bUnitChanged", cartOverview.name, cartOverview.handlers.onb2bUnitChange);

			}).fail(function (e) {
				console.log(e);
			});
		};


		return cartOverview;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});